<!--周报
以天为单位，单个设备，显示整点值
-->
<template>
	<div class="weekPowerQualityBody">
		<!--日期弹窗-->
		<datePicker ref="datePicker" :initDate='nowSelectDate' @selectDate="selectDate" type="day"></datePicker>
		<!--<virtualDeviceTree slot="tree" :dataList="virtualDeviceList" @checkItem="nowVirtualDevice = $event"></virtualDeviceTree>-->
		<elRadioTree slot="tree" :dataList='virtualDeviceList' @checkItem="nowVirtualDevice = $event"></elRadioTree>
		<div class="monreportRigth" slot="body">
			<div class="buttonLine">
				<!-- <multipleSelection title="应用类型组" nameKey="name" :list='apptypeGroups' @checkDataList="nowApptypeGroups = $event" :autoCheckIdList="[6]" @checkIdList="$store.cacheStore.commit('setNowSelectAppTypeGroupIds',$event)"></multipleSelection> -->
				  <label>应用类型组：</label>
				<el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择" size='small'>
					<el-option label='全选' value='全选' @click.native='selectAll'></el-option>
					<el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<!--日期-->
				<!-- <iconButton icoName="wedoButton/date.png" :buttonText="nowDateText" @buttonClick="$refs.datePicker.show()"></iconButton> -->
				<div class="block" style="margin-left:10px">
					<el-date-picker v-model="weekTimer" type="week" placeholder="选择日期"></el-date-picker>
				</div>
				<iconButton icoName="wedoButton/search.png" buttonText="查询" @buttonClick="search"></iconButton>
			</div>
			<!--图表-->
<!--			<vchart ref='vchart' style="height: calc(100% - 2.37rem);"></vchart>-->
			<vchart ref='vchart' style="height: calc(100% - 3.2rem);"></vchart>
			<!--表格显示数据-->
			<infoList ref="infoList" style="height: 2.5rem;" :columns='columns' :dataList="nowPage" :pageLen='pageLen' :totalSize="nowShowDataList.length" @selectPage="nowIndex = $event" :dataType='1' :fillAll="true"></infoList>
		</div>
	</div>
</template>

<script type="text/javascript">
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	export default {
		components: {
			treeBody,
			datePicker,
			virtualDeviceTree,
			iconButton,
			multipleSelection,
			vchart,
			infoList,
			elRadioTree,
		},
		props: [],
		data() {
			return {
				nowVirtualDevice: undefined,
				nowApptypeGroups: [],
				dataObject: {},
				totalSize: 0,
				nowIndex: 0,
				options: {},
				from2name: {},
				apptypeValue:[],
				weekTimer:""
			}
		},
		created() {},
		mounted() {
			debugPage = this
			//初始化图表
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.toolbox['iconStyle'] = {
				'color': 'white',
				'borderColor': 'white',
				'shadowColor': 'white'
			}

			this.$refs.vchart.setData(this.options, true)
		},
		destroyed() {},
		computed: {
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowSelectDate() {
				this.weekTimer = (this.$store.cacheStore.getters.getNowSelectDate).getTime()
				return this.$store.cacheStore.getters.getNowSelectDate
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			virtualDeviceList() {
				var appTypeNos = this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
				return [deviceList(this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(appTypeNos.join(','), this.nowUnit.id))]
			},
			nowDateText() {
				return this.nowSelectDate.formatByDate('-')
			},
			variableTree() {
				if(this.nowVirtualDevice == undefined) {
					return []
				}
				return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice.no)
			},
			nowVariableNames() {
				//当前应该显示的变量fromname列表
				var ag = []
				for(var i = 0, len = this.nowApptypeGroups.length; i < len; i++) {
					var item = this.nowApptypeGroups[i]
					if(item.id == -1 || item.id == -2) {
						ag = ag.concat(item.next.map(ni => {
							return ni.id
						}))
					} else {
						ag.push(item.id)
					}
				}
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.no)
				})
				if(isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						this.from2name[i.fromName] = i.name
						v2.push(i.fromName) //fromName
					})
				})
				return v2
			},
			apptypeGroups() {
				return this.$store.variableStore.state.powerApptypeGroup
			},
			nowShowDataList() {
				//当前应该显示的数据列表
				var list = []
				var baseList = []
				//只取出要显示的变量的数据
				for(var i = 0, len = this.nowVariableNames.length; i < len; i++) {
					var item = this.dataObject[this.nowVariableNames[i]]
					if(!isempty(item)) {
						baseList.push(item)
					}
				}
				//精简多余数据，只留下要显示的数据,这里是一个名称和七个值
				for(var i = 0, len = baseList.length; i < len; i++) {
					var item = baseList[i]
					var vList = []
					var name = undefined
					var fromName = ''
					for(var i2 = 0, len2 = baseList[i].length; i2 < len2; i2++) {
						var item2 = baseList[i][i2]
						if(!isempty(item2.variablename)) {
							fromName = item2.variablename
							var temp = this.from2name[item2.variablename] ? this.from2name[item2.variablename] : item2.variablename
							name = temp.subByFirstChar(".")
						}
						if(!isnull(item2.avg)) {
							vList.push(item2.avg)
							continue
						}
						//没有平均值，自己算
						var count = 0
						var sum = 0
						item2.data.forEach(value => {
							if(!isnull(value)) {
								//只计算有效值
								sum += value
								count++
							}
						})
						if(count == 0) {
							//一个有效值都没有
							vList.push(undefined)
							continue
						}
						vList.push(cutDigital(sum / count))
					}
					if(name == undefined) {
						continue
					}
					list.push({
						name,
						fromName,
						data: vList
					})
				}
				return list
			},
			columns() {
				//列表的项，每个整点值
				var list = [{
					name: "名称"
				}, {
					name: "星期一"
				}, {
					name: "星期二"
				}, {
					name: "星期三"
				}, {
					name: "星期四"
				}, {
					name: "星期五"
				}, {
					name: "星期六"
				}, {
					name: "星期日"
				}]
				return list
			},
			nowPage() {
				//按照页码来返回当前应该显示的列表
				var list = []
				var baseList = this.nowShowDataList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
				//排练数据，名称在第一个，后面按顺序显示数据
				for(var i = 0, len = baseList.length; i < len; i++) {
					var item = baseList[i]
					var vlist = []
					vlist.push(item.name) //nowShowDataList定义为name
					var res = item.data.map(i => {
						if(isNaN(parseFloat((i))) || isnull(parseFloat((i)))) {
							return undefined
						} else {
							return i
						}
					})
					vlist = vlist.concat(res)
					list.push(vlist)
				}
				return list
			},
			allVariableName() {
				//所有的通讯变量名称
				var list = []
				for(var i = 0, len = this.variableTree.length; i < len; i++) {
					var next = this.variableTree[i].next
					for(var i2 = 0, len2 = next.length; i2 < len2; i2++) {
						var item = next[i2]
						list.push(item.fromName) //fromName
					}
				}
				return list
			},
			pageLen() {
				return this.nowVariableNames.length < 6 ? 6 : this.nowVariableNames.length
			}
		},
		watch: {
			nowDevice(nv, ov) {
				this.dataObject = []
			},
			nowShowDataList(nv, ov) {
				//获取到新的数据了，重新渲染
				this.reloadChart(nv)
				this.nowIndex = 0
			},
			allVariableName(nv, ov) {
				this.search()
			},
			nowSelectDate(nv, ov) {
				this.search()
			}
		},
		methods: {
			//新下拉框
				selectAll() {
					console.log("apptypeGroups",this.apptypeGroups);
				//全选 先判断是否有选中的，有选中就清空
				if(this.apptypeValue.length==1) {
					this.nowApptypeGroup = this.apptypeGroups
					let idList = []
					this.apptypeGroups.forEach(item => {
						idList.push(item.id)
					})
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', idList)
					this.apptypeValue = idList
				}else{
					this.nowApptypeGroup =[]
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', [])
					this.apptypeValue=[]
				}
			},
			selectDate(date) {
				this.$store.cacheStore.commit("setNowSelectDate", date)
				this.$refs.datePicker.hide()
			},
			search() {
				if(isempty(this.virtualDeviceList)) {
					return
				}
				if(this.nowVirtualDevice == undefined) {
					this.$dialogMethod.showMessage('请先选中设备！')
					return
				}
				if(isempty(this.allVariableName)) {
					return
				}
				this.$dialogMethod.showLoading('数据正在加载...')
				//查询数据
				this.$api.historyApi.searchVariableHistoryWithDateType(this.allVariableName.join(','), 'week', this.nowSelectDate.getTime(),
					respon => {
						//补上缺失数据
						var keys = Object.keys(respon)
						for(var i = 0, len = keys.length; i < len; i++) {
							var key = keys[i]
							var list = respon[key]
							list.forEach(item => {
								if(item.data == undefined) {
									item.data = []
									item.variablename = key
									item.avg = -1.1111
									item.max = -1.1111
									item.min = -1.1111
									item.next = -1.1111
								}
							})
						}
						this.dataObject = respon
						this.$dialogMethod.closeLoading()
					})
			},
			exportExcel() {

			},
			reloadChart(list) {
				var selected = {}
				var legend = []
				var seriesList = []
				var weekList = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
				for(var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					var name = item.name
					var vList = []
					for(var i2 = 0, len2 = item.data.length; i2 < len2; i2++) {
						var item2 = item.data[i2]
						if(isNaN(parseFloat(item2)) || isnull(parseFloat(item2))) {
							item2 = undefined
						}
						vList.push([weekList[i2], item2])
					}
					seriesList.push({
						name: name,
						type: 'line',
						smooth: true,
						symbol: 'none',
						sampling: 'average',
						data: vList,
					})
					selected[name] = i < 6 ? true : false
					legend.push({
						name: name,
						icon: 'roundRect'
					})
				}
				this.options.series = seriesList
				this.options.legend.data = legend
				this.options.legend.selected = selected
				this.options.title.text = this.nowVirtualDevice.name + '-周电能质量'
				this.$refs.vchart.setData(this.options, true)
			}
		}
	}
</script>

<style scoped lang="scss">
	.monthReportBody {
		width: 100%;
		height: 100%;
		display: flex;
	}
	
	.monreportLeft {
		height: 99%;
	}
	
	.monreportRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
		background-color: #fff;
	}
	
	.tableData {
		width: 100%;
	}
	/deep/.el-input__inner {
		height: 32px;
		line-height: 32px;
	}
	/deep/.el-icon-date {
		line-height: 32px;
	}
	
	.tableData tr:nth-child(1) td {
		text-align: center;
		border: .01rem solid;
		margin-top: .1rem;
	}
	
	.weekPowerQualityBody {
		width: 100%;
		display: flex !important;
		/* align-items: center; */
		justify-content: space-between;
	}
</style>